<template>
    <div class="functionalservice">
        <!--<div class="wrap">-->
            <!--<div class="open unopen_list">-->
                <!--<div class="title">未开通</div>-->
                <!--<div class="list flex">-->
                    <!--<div class="list_item" v-for="(item, index) in unopenList">-->
                        <!--<div class="img_name flex">-->
                            <!--<div class="img flex"><img :src="item.moduletype === 2 ? imgList.star : item.moduletype === 3 ? imgList.distribution : item.moduletype === 4 ? imgList.salesgroup : item.moduletype === 5 ? imgList.salesone : imgList.assist"></div>-->
                            <!--<div class="name_desp">-->
                                <!--<p class="name">{{item.modulename}}</p>-->
                                <!--<p class="desp">打造商业人群共享的专业智库平台</p>-->
                            <!--</div>-->
                        <!--</div>-->
                        <!--<div class="price_detail flex">-->
                            <!--<div class="price">¥{{item.modulemoney}}/年</div>-->
                            <!--<div class="detail_btn" @click="checkDetail(item)">查看详情</div>-->
                        <!--</div>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->
        <!--</div>-->
        <div class="wrap open_list">
            <div class="open">
                <!--<div class="title">已开通</div>-->
                <div class="list flex">
                    <div class="list_item" v-for="(item, index) in openList">
                        <div class="vip icon icon_vip" v-if="item.modulevertype==2"></div>
                        <div class="img_name flex">
                            <div class="img flex" :class="['icon_service_tool'+item.moduletype]"></div>
                            <div class="name_desp">
                                <p class="name">{{item.modulename}}</p>
                                <p class="desp">{{item.moduledesp}}</p>
                            </div>
                        </div>
                        <div class="price_detail flex">
                            <div class="price">¥{{item.modulemoney}}/年</div>
                            <div class="detail_btn continue" @click="item.status ? continueOrder(item) : ''">{{item.modulevertype==1?'升级':'续订'}}</div>
                        </div>
                        <div class="endtime">有效期至 {{item.expireendtime}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getFunctionshopmoduleList, savePriceBuyInfo} from '@/api/orderService'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'functionalService',
    data() {
        return {
            // isopenmodule:是否购买 0未购买  1已购买;
            // moduletype: 2星球社群  3分销返利 4社群拼购   5 1元购   6助力砍价 7报名活动 8抽奖有礼 9多人拼团
            // modulevertype 1 普通用户 2 高级用户
            unopenList: [],
            openList: []
        }
    },
    mounted() {
        this.checkFuncService()
    },
    methods: {
        checkFuncService() {
            getFunctionshopmoduleList({
                data: {},
                success: data => {
                    this.setLoading(false)
                    if (data.data) {
                        this.unopenList = data.data.unopenlist
                        this.openList = data.data.openlist
                    }
                },
                error:data => {
                    this.setLoading(false)
                }
            })
        },

        // 查看详情
        checkDetail(item) {
            this.$router.push({name: 'serviceDetail', query: {'modulename': item.modulename, 'modulemoney': item.modulemoney}})
        },

        // 续订
        continueOrder(obj) {
            this.$router.push({name: 'orderConfirm', query: {modulecode: obj.modulecode}})
            // type = type === '星球' ? '2' : type === '分销' ? '3' : type === '拼购' ? '4' : type === '1元购' ? '5' : '助力' ? '6' : ''
            // let data = {
            //     moduletype: type
            // }
            // this.setLoading(true)
            // savePriceBuyInfo({
            //     data: data,
            //     success: data => {
            //         this.setLoading(false)
            //         this.orderno = data.data.orderno
            //         if (data.data.ispaysuccess === 2) {
            //             this.$router.push({name: 'orderConfirm', query: {'orderno': data.data.orderno}})
            //         } else {
            //             window.location = data.data.url
            //         }
            //     },
            //     error: data => {
            //         this.setLoading(false)
            //         this.$message.error(data.msg)
            //     }
            // })
        },

        ...mapActions ([
            'setLoading'
        ])
    }
}
</script>

<style lang="scss">
.flex {
    display: flex;
}
.functionalservice {
    .wrap {
        background: #fff;
        padding: 20px;
        .open {
            .title {
                font-size: 18px;
                color: #303133;
                margin-bottom: 20px;
            }
            .list {
                flex-wrap: wrap;
                .list_item {
                    width: calc((100% - 60px ) / 3);
                    flex-wrap: wrap;
                    height: 140px;
                    background:rgba(245,247,250,1);
                    box-shadow: 4px 4px 20px 0px rgba(0,14,63,0.16);
                    margin-right: 30px;
                    margin-bottom: 30px;
                    position: relative;
                    .vip{
                        width: 72px;
                        height: 24px;
                        position: absolute;
                        right: 0;
                        top:0;
                    }
                    .img_name {
                        padding: 15px;
                        border-bottom: 1px solid #E4E7ED;
                        .img {
                            width: 50px;
                            min-width: 50px;
                            height: 50px;
                            background: linear-gradient(180deg,rgba(23,185,254,1) 0%,rgba(14,137,253,1) 100%);
                            border-radius: 2px;
                            justify-content: center;
                            align-items: center;
                            margin-right: 12px;
                            &:before {
                                display: inline-block;
                                width: 36px;
                                height: 36px;
                            }
                        }
                        .name_desp {
                            height: 50px;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            .name {
                                font-size: 16px;
                                color: #303133;
                            }
                            .desp {
                                font-size: 14px;
                                color: #909399;
                            }
                        }
                    }
                    .price_detail {
                        padding: 15px;
                        justify-content: space-between;
                        .price {
                            color: #F56C6C;
                            font-size: 16px;
                        }
                        .detail_btn {
                            width: 108px;
                            height: 32px;
                            border-radius: 16px;
                            border: 1px solid rgba(64,158,255,1);
                            font-size: 14px;
                            color: #409EFF;
                            line-height: 32px;
                            text-align: center;
                            cursor: pointer;
                            &:hover{
                                border: 1px solid #409EFF;
                                color: #409EFF;
                            }
                        }
                    }
                }
                .list_item:nth-child(3n) {
                    margin-right: unset;
                }
            }
        }
    }
    .open_list {
        min-height: 500px;
        .open {
            .list {
                .list_item {
                    height: 172px;
                    .price_detail {
                        // padding: 10px 15px;
                        .detail_btn {
                            border: 1px solid #C0C4CC;
                            color: #303133;
                        }
                    }
                    .endtime {
                        color: #C0C4CC;
                        font-size: 16px;
                        padding: 0 15px;
                    }
                }
            }
        }
    }
}
</style>


